import { formatImporte } from '@/utils/money';
import {
  Checkbox,
  Grid,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Slide,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Layout } from '../../components/ui/Layout';
import MUIDataTable from 'mui-datatables';
import { TransitionsModal } from '../../components/ui/TransitionModal';
import { NotificationModal } from '../../components/ui/NotificationModal';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeFilter,
  changeFilterDates,
  changeFilterField,
  setActiveInvoice,
  setActiveInvoiceToExport,
  startDownloadCSVInvoices,
  startDownloadCSVInvoicesWithOutFilter,
  startHandlingFilter,
  startLoadSales,
  startResetPage,
} from '../../redux/actions/sales';
import { Spinner } from '../../components/ui/Spinner';
import Autocomplete from '@mui/material/Autocomplete';
import { useDebounce } from '../../hooks/useDebounce';
import { useDebounceComplex } from '../../hooks/useDebounceComplex';

import {
  FACTURADO,
  NUMROWSTATEINVOICE,
  PENDIENTEFACTURAR,
  PENDIENTEPRESUPUESTO,
  PENDIENTERESERVA,
  PENDIENTEVOUCHER,
  ROLADMIN,
  ROLREVENDEDOR,
  ROLVENDEDOR,
} from '../../utils/constants';
import { RangePickerMUI } from '../../components/ui/RangePickerMUI';
import clsx from 'clsx';
import { useTableStyles } from '../../styles/useTableUsersStyles';
import share from '../../images/share.png';
import pdf from '../../images/pdf.png';
import { startLogOutLines } from '../../redux/actions/lines';
import { SnackBar } from '../../components/ui/SnackBar';
import { getDateDayPlusTwo, getDateMonthMinusOne } from '../../utils/dates';
import Swal from 'sweetalert2';
import { isMatrixEmpty } from '../../utils/utils';
import { navigate } from '@reach/router';
import { startContentDeleteInvoice, startContentPDFDownload } from '../../redux/actions/contentModal';
import { uiManageModalNotification } from '../../redux/actions/ui';
import deleteIcon from '../../images/trash.png';
import { ButtonFloatNoOptions } from '../../components/ui/ButtonFloatNoOptions';

import Alert from '@mui/material/Alert';

import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import esLocale from 'date-fns/locale/es';
import { Form, Formik } from 'formik';

import moment from 'moment-timezone';

moment.tz.setDefault('Europe/Madrid');

function TransitionDown(props) {
  return <Slide {...props} direction="down" />;
}

const SalesScreen = () => {
  const { idRol, urlB2B, moneda: monedaUsuario } = useSelector(state => state.auth);

  const result = [];
  const theme = useTheme();
  const { year, month, day } = getDateDayPlusTwo();
  const { yearY, monthY, dayY } = getDateMonthMinusOne();
  const classes = useTableStyles();
  const dispatch = useDispatch();
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const matchesMD = useMediaQuery(theme.breakpoints.down('md'));
  const { menuState } = useSelector(state => state.ui);
  const {
    invoices: {
      dateRange,
      currentFilter: filterOptions,
      dateFilterField,
      page,
      data,
      count,
      sum,
      sumInSituEuros,
      sumReservaEuros,
      sumDescuentoEuros,
      sumReventaEuros,
      sumBalanceDolares,
    },
  } = useSelector(state => state.invoice);
  const [searchClientes, debounceSearchResultClientes] = useDebounceComplex('/clientes/search/', {
    start: 'Nombre',
    second: 'Apellidos',
    end: 'Email',
    id: 'PkClientes',
  });

  const [searchUsuarios, debounceSearchResultUsuarios] = useDebounce('/usuarios?filter[where][Nombre][like]', {
    start: 'Nombre',
    end: 'Email',
    id: 'PkUsuarios',
  });

  const [searchComisionistas, debounceSearchComisionistas] = useDebounce('/comisionistas?filter[where][Nombre][like]', {
    start: 'Nombre',
    end: 'Email',
    id: 'PkComisionistas',
  });

  const { loading } = useSelector(state => state.ui);
  const { route } = useSelector(state => state.route);
  // const [dateRange, setDateRange] = useState([new Date(yearY, monthY, dayY).toISOString(), new Date( year, month, day ).toISOString()])
  // const [filterOptions, setFilterOptions] = useState([]);
  const [openSnack, setopenSnack] = useState(false);
  const [transition, setTransition] = useState(undefined);
  const [statePosition, setStatePosition] = useState({
    vertical: 'top',
    horizontal: 'center',
  });

  useEffect(() => {
    dispatch(startLogOutLines());
  }, [dispatch]);

  useEffect(() => {
    //if( isMatrixEmpty(filterOptions) ){
    //  dispatch(startLoadSales( page, dateRange ))
    //}
    //else{
    //console.log('dispatch');
    //console.log(filterOptions);
    //console.log(page);
    dispatch(startHandlingFilter(filterOptions, page, dateRange, dateFilterField));
    //}
  }, []); // [page, dispatch, dateRange, filterOptions]);

  useEffect(() => {
    if (route) {
      navigate(route);
    }
  }, [route]);

  const handleDownload = () => {
    if (!isMatrixEmpty(filterOptions)) {
      dispatch(startDownloadCSVInvoices(filterOptions, page, dateRange, dateFilterField));
    } else {
      dispatch(startDownloadCSVInvoicesWithOutFilter(dateRange, dateFilterField));
    }
  };

  const handleEdit = (dataIndex, e) => {
    if (e) e.stopPropagation();
    navigate(`/sales/invoice/${data[dataIndex].PkVentas}`);
  };

  const handleDelete = (dataIndex, e) => {
    if (e) e.stopPropagation();
    Promise.resolve(dispatch(setActiveInvoiceToExport(data[dataIndex].PkVentas)))
      .then(() => {
        dispatch(startContentDeleteInvoice());
      })
      .then(() => {
        dispatch(uiManageModalNotification());
      });
  };

  const showDeleteButton = dataIndex => {
    return idRol === ROLADMIN || !data[dataIndex].OrigenB2B;
  };

  const showDownloadButton = dataIndex => {
    return !data[dataIndex].OrigenB2B;
  };

  const handleOpenSnackbar = (dataIndex, Transition, e) => {
    if (e) e.stopPropagation();
    Promise.resolve(dispatch(setActiveInvoiceToExport(data[dataIndex].PkVentas)))
      .then(() => {
        setTransition(() => Transition);
        setopenSnack(true);
      })
      .catch(() => {
        Swal.fire('Error', 'Está opción no está disponible. Contacte con el administrador', 'error');
      });
  };

  const handleDownloadPDFBudget = (dataIndex, e) => {
    if (e) e.stopPropagation();
    Promise.resolve(dispatch(setActiveInvoiceToExport(data[dataIndex].PkVentas)))
      .then(() => {
        dispatch(startContentPDFDownload());
      })
      .then(() => {
        dispatch(uiManageModalNotification());
      });
  };

  const handleEstadoChange = (filterList, onChange, index, column) => event => {
    const filterValue = event.target.value;
    filterList[3][0] = filterValue;
    console.log(filterValue);

    if (filterValue === 'Pendiente Facturar') {
      console.log('SELECT pend fact');
    } else if (filterValue === 'Facturado') {
      console.log('SELECT fact');
    }

    onChange(filterList[3], index, column);
    //console.log( filterList )
  };

  const columns = [
    {
      label: 'Número',
      name: 'Numero',
      options: {
        filter: true,
        filterList: filterOptions ? filterOptions[0] : [],
        display: !matchesXS,
        sort: false,
        filterType: 'textField',
        /*filterOptions:{
             display: (filterList, onChange, index, column) => {
               return (
                 <FormControl>
                  
                  <TextField
                      fullWidth   
                      label='Número'
                      size='small'
                      variant='outlined'
                      style={{ marginTop: '2rem' }}
                      classes={{ root: classes.inputText }} 
                      onChange={(e, newInputValue) => {
                        console.log('new input');
                        console.log(e);
                        filterList[1][0] = e.target.value;
                        onChange(filterList[1], index, column)
                      }}
                      InputProps={{
                          classes: {
                              input: classes.resize
                          }
                      }}
                      InputLabelProps={
                          {style: {fontSize: '0.8em'}}
                      }
                                               
                  />
                  
                 </FormControl>
               );
             }
           } */
      },
    },
    {
      label: 'Cliente',
      name: 'Cliente',
      options: {
        filter: true,
        filterList: filterOptions ? filterOptions[1] : [],
        display: true,
        sort: false,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            return (
              <FormControl>
                <Autocomplete
                  id="combo-box-client"
                  options={searchClientes}
                  sx={{ width: 300 }}
                  noOptionsText={`No hay clientes`}
                  onInputChange={debounceSearchResultClientes}
                  onChange={(_, newInputValue) => {
                    filterList[1][0] = newInputValue?.value;
                    onChange(filterList[1], index, column);
                  }}
                  renderInput={params => <TextField {...params} label="Cliente" />}
                />
              </FormControl>
            );
          },
        },
      },
    },
    {
      label: 'Fecha',
      name: 'FechaVenta',
      options: {
        filter: false,
        display: !matchesXS,
        sort: false,
      },
    },
    {
      label: 'Hotel',
      name: 'Hotel',
      options: {
        filter: false,
        display: !matchesXS,
        sort: false,
      },
    },
    {
      label: 'Estado reserva',
      name: 'Estado reserva',
      options: {
        filter: true,
        filterList: filterOptions ? filterOptions[4] : [],
        display: true,
        sort: false,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            const optionValues = [
              PENDIENTEPRESUPUESTO,
              PENDIENTERESERVA,
              PENDIENTEVOUCHER,
              PENDIENTEFACTURAR,
              FACTURADO,
            ];

            return (
              <FormControl>
                <InputLabel htmlFor="select-multiple-chip">Estado</InputLabel>
                <Select
                  value={filterList[index]}
                  renderValue={selected => selected.join(', ')}
                  onChange={handleEstadoChange(filterList, onChange, index, column)}>
                  {optionValues.map(item => (
                    <MenuItem key={item} value={item}>
                      <Checkbox color="primary" checked={filterList[3].indexOf(item) > -1} />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          },
        },
      },
    },
    {
      label: 'Vendedor',
      name: 'Vendedor',
      options: {
        filter: idRol == ROLADMIN,
        filterList: filterOptions ? filterOptions[5] : [],
        display: !matchesXS,
        sort: false,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            return (
              <FormControl>
                <Autocomplete
                  id="combo-box-client"
                  options={searchUsuarios}
                  sx={{ width: 300 }}
                  noOptionsText={`No hay usuarios`}
                  onInputChange={debounceSearchResultUsuarios}
                  onChange={(event, newInputValue) => {
                    filterList[4][0] = newInputValue?.value;
                    onChange(filterList[4], index, column);
                  }}
                  renderInput={params => <TextField {...params} label="Vendedor" />}
                />
              </FormControl>
            );
          },
        },
      },
    },
    {
      label: 'Importe',
      name: 'Importe',
      options: {
        filter: false,
        display: false,
        sort: false,
      },
    },
    {
      label: 'Reserva',
      name: 'Importe',
      options: {
        filter: false,
        display: false,
        sort: false,
      },
    },
    {
      label: 'In situ',
      name: 'InSituConTransporteEuros',
      options: {
        filter: false,
        display: false,
        sort: false,
      },
    },
    {
      label: 'Margen Revendedor (€)',
      name: 'ReventaEuros',
      options: {
        filter: false,
        display: false, //(!matchesXS && idRol !== ROLCOLABORADOR)
        viewColumns: idRol === ROLADMIN,
        sort: false,
      },
    },
    {
      label: 'Margen Revendedor ($)',
      name: 'ReventaDolares',
      options: {
        filter: false,
        display: false, //(!matchesXS && idRol !== ROLCOLABORADOR)
        viewColumns: idRol === ROLADMIN,
        sort: false,
      },
    },
    {
      label: 'Pago Agencia Realizado',
      name: 'ReservaPagadaAgencia',
      options: {
        filter: false,
        display: false, //(!matchesXS && idRol !== ROLCOLABORADOR)
        viewColumns: idRol === ROLADMIN,
        sort: false,
      },
    },
    {
      label: 'Balance Proveedor',
      name: 'BalanceDolares',
      options: {
        filter: false,
        display: !matchesXS && (idRol === ROLADMIN || idRol === ROLVENDEDOR),
        viewColumns: idRol === ROLADMIN,
        sort: false,
      },
    },
    {
      label: 'Comisión Vendedor',
      name: 'ImporteComisionVendedor',
      options: {
        filter: false,
        display: false, //!matchesXS && (idRol === ROLADMIN || idRol === ROLREVENDEDOR),
        viewColumns: idRol === ROLADMIN,
        sort: false,
      },
    },
    {
      label: 'Comisionista',
      name: 'Comisionista',
      options: {
        filter: idRol === ROLADMIN || idRol === ROLVENDEDOR,
        viewColumns: idRol === ROLADMIN || idRol === ROLVENDEDOR,
        filterList: filterOptions ? filterOptions[11] : [],
        display: false,
        sort: false,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            return (
              <FormControl>
                <Autocomplete
                  id="combo-box-client"
                  options={searchComisionistas}
                  sx={{ width: 300 }}
                  noOptionsText={`No hay comisionistas`}
                  onInputChange={debounceSearchComisionistas}
                  onChange={(_, newInputValue) => {
                    filterList[11][0] = newInputValue?.value;
                    onChange(filterList[11], index, column);
                  }}
                  renderInput={params => <TextField {...params} label="Comisionista" />}
                />
              </FormControl>
            );
          },
        },
      },
    },
    {
      name: 'Acciones',
      options: {
        filter: false,
        display: true,
        sort: false,
        customBodyRenderLite: dataIndex => {
          return (
            <div>
              {showDeleteButton(dataIndex) && (
                <IconButton
                  style={{ color: `#000`, width: '1rem', height: '1rem' }}
                  onClick={e => handleDelete(dataIndex, e)}>
                  <img src={`${deleteIcon}`} alt="img" />
                </IconButton>
              )}

              <IconButton
                style={{ color: `#000`, width: '1rem', height: '1rem' }}
                onClick={e => handleOpenSnackbar(dataIndex, TransitionDown, e)}>
                <img src={`${share}`} alt="img" />
              </IconButton>

              {showDownloadButton(dataIndex) && (
                <IconButton
                  style={{ color: `#000`, width: '1rem', height: '1rem' }}
                  onClick={e => handleDownloadPDFBudget(dataIndex, e)}>
                  <img src={`${pdf}`} alt="img" />
                </IconButton>
              )}
            </div>
          );
        },
        setCellHeaderProps: () => {
          return {
            className: clsx({
              [classes.NameCell]: true,
            }),
            style: {
              fontSize: 15,
              fontWeight: 500,
            },
          };
        },
      },
    },
  ];
  const options = {
    filterType: 'custom', //'textField',
    responsive: 'standard',
    filename: 'Ventas',
    rowsPerPage: NUMROWSTATEINVOICE,
    serverSide: true,
    count: count,
    page,
    rowsPerPageOptions: [],
    onTableChange: (action, tableState) => {
      //console.log('tableState');
      //console.log(tableState);

      if (action === 'changePage') {
        dispatch(startHandlingFilter(tableState.filterList, tableState.page, dateRange, dateFilterField));
      }
    },
    print: false,
    download: idRol === ROLADMIN || idRol === ROLVENDEDOR ? true : false,
    selectableRowsHideCheckboxes: true,
    selectableRowsOnClick: false,
    onFilterChange: (_, filterList) => {
      //setFilterOptions(filterList);
      //dispatch(startResetPage())
      dispatch(changeFilter(filterList, page, dateRange, dateFilterField));
    },
    draggableColumns: {
      enabled: true,
    },
    textLabels: {
      body: {
        noMatch: loading ? <Spinner /> : 'Lo siento, no se han encontrado registros',
      },
      pagination: {
        next: 'Siguiente',
        previous: 'Anterior',
        rowsPerPage: 'Filas por página',
        displayRows: 'de',
      },
      toolbar: {
        search: 'Buscar',
        downloadCsv: 'Descargar CSV',
        viewColumns: 'Consultar Columnas',
        filterTable: 'Filtrar Tabla',
      },
      filter: {
        all: 'Incluir dados de baja',
        title: 'Fitros',
        reset: 'Reset',
      },
      viewColumns: {
        title: 'Mostrar Columnas',
        titleAria: 'Mostrar/Ocultar Columnas Tablas',
      },
      selectedRows: {
        text: 'fila(s) seleccionadas',
        delete: 'Borrar',
        deleteAria: 'Borrar filas seleccionadas',
      },
    },
    searchOpen: false,
    search: false,

    onRowClick: (rowData, rowMeta) => {
      handleEdit(rowMeta.dataIndex);
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      if (idRol === ROLADMIN || idRol === ROLVENDEDOR) {
        handleDownload();
      }
      return false;
    },
  };

  data.map(element => {
    let estado = '';
    if (element.FechaFactura) {
      estado = 'Facturada';
    } else {
      estado = !element.PresupuestoEnviado
        ? 'Pendiente de Enviar'
        : !element.ReservaPagada
        ? 'Pendiente de Pago de Reserva'
        : !element.VoucherEnviado
        ? 'Pendiente de Envío de Voucher'
        : 'Confirmada';
    }

    if (idRol !== ROLREVENDEDOR) {
      result.push([
        element.PkVentas,
        element.Cliente.Nombre,
        moment(element.FechaVenta).format('DD/MM/YYYY'),
        element.HotelCliente,
        estado,
        element.Usuario.Nombre,
        formatImporte(element.Importe, 'EUR'),
        formatImporte(element.ReservaEuros, 'EUR'),
        formatImporte(element.InSituConTransporteEuros, 'EUR'),
        formatImporte(element.ReventaEuros, 'EUR'),
        formatImporte(element.ReventaDolares, 'USD'),
        element?.Usuario?.EsAgencia ? (element?.ReservaPagadaAgencia ? 'Sí' : 'Pendiente') : '',
        idRol === ROLADMIN || idRol === ROLVENDEDOR ? formatImporte(element.BalanceDolares, 'USD') : '',

        idRol === ROLADMIN || idRol === ROLREVENDEDOR ? formatImporte(element.ImporteComisionVendedor, 'USD') : '',

        idRol === ROLADMIN || idRol === ROLVENDEDOR ? element.Comisionista?.Nombre : '',
      ]);
    } else {
      if (monedaUsuario === 'USD') {
        result.push([
          element.PkVentas,
          element.Cliente.Nombre,
          moment(element.FechaVenta).format('DD/MM/YYYY'),
          element.HotelCliente,
          estado,
          element.Usuario.Nombre,
          formatImporte(element.ImporteDolares, 'USD'),
          formatImporte(element.ReservaDolares, 'USD'),
          formatImporte(element.InSituDolares + element.SuplementoTransporteDolares, 'USD'),
          formatImporte(element.ReventaEuros, 'EUR'),
          formatImporte(element.ReventaDolares, 'USD'),
          element?.Usuario?.EsAgencia ? (element?.ReservaPagadaAgencia ? 'Sí' : 'Pendiente') : '',
          idRol === ROLADMIN || idRol === ROLVENDEDOR ? formatImporte(element.BalanceDolares, 'USD') : '',

          idRol === ROLADMIN || idRol === ROLREVENDEDOR ? formatImporte(element.ImporteComisionVendedor, 'USD') : '',

          idRol === ROLADMIN || idRol === ROLVENDEDOR ? element.Comisionista?.Nombre : '',
        ]);
      } else {
        result.push([
          element.PkVentas,
          element.Cliente.Nombre,
          moment(element.FechaVenta).format('DD/MM/YYYY'),
          element.HotelCliente,
          estado,
          element.Usuario.Nombre,
          formatImporte(element.Importe, 'EUR'),
          formatImporte(element.ReservaEuros, 'EUR'),
          formatImporte(element.InSituConTransporteEuros, 'EUR'),
          formatImporte(element.ReventaEuros, 'EUR'),
          formatImporte(element.ReventaDolares, 'USD'),
          element?.Usuario?.EsAgencia ? (element?.ReservaPagadaAgencia ? 'Sí' : 'Pendiente') : '',
          idRol === ROLADMIN || idRol === ROLVENDEDOR ? formatImporte(element.BalanceDolares, 'USD') : '',

          idRol === ROLADMIN || idRol === ROLREVENDEDOR ? formatImporte(element.ImporteComisionVendedor, 'EUR') : '',

          idRol === ROLADMIN || idRol === ROLVENDEDOR ? element.Comisionista?.Nombre : '',
        ]);
      }
    }

    return null;
  });

  return (
    <Layout>
      <Helmet>
        <title>Reservas | Xplora</title>
      </Helmet>

      <div
        style={{
          marginTop: '2rem',
          display: 'flex',
          flexDirection: 'column',
          width: `${matchesXS ? '95vw' : matchesMD ? (menuState ? '55vw' : '85vw') : menuState ? '82vw' : '91vw'}`,
        }}>
        {!matchesXS && (
          <Typography variant="h2" style={{ marginLeft: '1.7rem' }}>
            RESERVAS
          </Typography>
        )}

        {(idRol === ROLADMIN || idRol === ROLVENDEDOR) && (
          <>
            <Alert severity="info" style={{ alignSelf: 'flex-start', display: 'inline-flex' }}>
              <strong>Total reservas:</strong> {formatImporte(sum, 'EUR')}
              {matchesXS && <br />}
              <strong style={{ marginLeft: '0.8rem' }}>Insitu:</strong> {formatImporte(sumInSituEuros, 'EUR')}
              {matchesXS && <br />}
              <strong style={{ marginLeft: '0.8rem' }}>Reserva:</strong> {formatImporte(sumReservaEuros, 'EUR')}
              {matchesXS && <br />}
              <strong style={{ marginLeft: '0.8rem' }}>Descuento:</strong> {formatImporte(sumDescuentoEuros, 'EUR')}
              {idRol === ROLADMIN && (
                <>
                  {matchesXS && <br />}
                  <strong style={{ marginLeft: '0.8rem' }}>Margen Revendedor:</strong>{' '}
                  {formatImporte(sumReventaEuros, 'EUR')}
                  {matchesXS && <br />}
                  <strong style={{ marginLeft: '0.8rem' }}>Balance con proveedores:</strong>{' '}
                  {formatImporte(sumBalanceDolares, 'USD')}
                </>
              )}
            </Alert>
          </>
        )}

        <LocalizationProvider dateAdapter={AdapterDateFns} locale={esLocale}>
          <Formik
            initialValues={{
              FechaDesde: dateRange[0],
              FechaHasta: dateRange[1],
            }}>
            {({ values, setFieldValue }) => (
              <Form>
                <Grid style={{ marginTop: '0.8rem' }} container spacing={matchesXS ? 2 : 0}>
                  <Grid
                    item
                    md={2}
                    xs={12}
                    classes={{ root: classes.container }}
                    style={matchesXS ? {} : { paddingRight: 10 }}>
                    <FormControl fullWidth>
                      <InputLabel id="reservas-fecha-filter-label">Filtrar por</InputLabel>
                      <Select
                        labelId="reservas-fecha-filter-label"
                        value={dateFilterField}
                        onChange={event => {
                          const nextValue = event.target.value;
                          dispatch(changeFilterField(nextValue));
                          dispatch(startHandlingFilter(filterOptions, page, dateRange, nextValue));
                        }}>
                        <MenuItem value="FechaVenta">Fecha de venta</MenuItem>
                        <MenuItem value="FechaPagoReserva">Fecha de pago de reserva</MenuItem>
                        <MenuItem value="FechaActividad">Fecha de actividad</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    md={2}
                    xs={12}
                    classes={{ root: classes.container }}
                    style={matchesXS ? {} : { paddingLeft: 40 }}>
                    <DesktopDatePicker
                      name="FechaDesde"
                      keyboard
                      label={`Fecha Desde`}
                      format="dd/MM/yyyy"
                      placeholder="10/10/2018"
                      mask={value => (value ? [/[0-3]/, /\d/, '/', /0|1/, /\d/, '/', /1|2/, /\d/, /\d/, /\d/] : [])}
                      disableOpenOnEnter
                      onChange={value => {
                        let dateselected = moment(value).add(2, 'hours').utcOffset(0);
                        dateselected.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
                        dateselected.toISOString();
                        dateselected.format();

                        setFieldValue(`FechaDesde`, value);
                        //setDateRange([dateselected, dateRange[1]]);
                        dispatch(changeFilterDates(filterOptions, page, [dateselected, dateRange[1]], dateFilterField));
                      }}
                      value={values.FechaDesde}
                      renderInput={params => <TextField fullWidth {...params} />}
                    />
                  </Grid>

                  <Grid
                    item
                    md={2}
                    xs={12}
                    classes={{ root: classes.container }}
                    style={matchesXS ? {} : { paddingLeft: 20 }}>
                    <DesktopDatePicker
                      name="FechaHasta"
                      keyboard
                      label={`Fecha Hasta`}
                      format="dd/MM/yyyy"
                      placeholder="10/10/2018"
                      mask={value => (value ? [/[0-3]/, /\d/, '/', /0|1/, /\d/, '/', /1|2/, /\d/, /\d/, /\d/] : [])}
                      disableOpenOnEnter
                      onChange={value => {
                        const dateselected = moment(value).endOf('day');
                        setFieldValue(`FechaHasta`, value);
                        dispatch(changeFilterDates(filterOptions, page, [dateRange[0], dateselected], dateFilterField));
                      }}
                      value={values.FechaHasta}
                      renderInput={params => <TextField fullWidth {...params} />}
                    />
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </LocalizationProvider>

        {
          // <RangePickerMUI value={ dateRange } setValue={ setDateRange }/>
        }
        <MUIDataTable data={result} columns={columns} options={options} />

        <TransitionsModal />
        <NotificationModal />

        {idRol !== ROLREVENDEDOR && <ButtonFloatNoOptions action={() => navigate('/sales/invoice')} />}

        <SnackBar
          open={openSnack}
          setOpen={setopenSnack}
          transition={transition}
          statePosition={statePosition}
          setStatePosition={setStatePosition}
        />
      </div>
    </Layout>
  );
};

export default SalesScreen;
